<div class="isg-companylist-wrapper"
     [style.height.px]="heightControl()">

  <div *ngIf="showToolbar" class="isg-companylist-toolbar">

    <div>
      <kendo-textbox placeholder="Filter companies..."
                     (valueChange)="onFilterChange($event)"
                     [clearButton]="true">
        <ng-template kendoTextBoxSuffixTemplate>
          <kendo-svg-icon [icon]="searchIcon"></kendo-svg-icon>
        </ng-template>
      </kendo-textbox>
    </div>

  </div>

  <div class="isg-companylist-lb-wrapper">
    <kendo-listview #companyList
                    width="100%"
                    [data]="dataItems"
                    [style.height.px]="heightListView()">
      <ng-template kendoListViewItemTemplate let-dataItem let-index>

        <div [ngClass]="{ 'isg-lv-item-selected': dataItem.id == selectedItem?.id, 'isg-lv-item' : (true)}"
             (click)="onClickItemEvent(index, dataItem, $event)">
          <span>{{ dataItem.name }}</span>
        </div>

      </ng-template>
    </kendo-listview>
  </div>

</div>
